/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getMedicationDetails } from 'app/entities/medication-details/medication-details.reducer';
import { getEntities as getMedicationScheduleDetails } from 'app/entities/medication-schedule-details/medication-schedule-details.reducer';
import { createEntity, getEntity, reset, updateEntity } from './medication-medicines.reducer';

export const MedicationMedicinesUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const medicationDetails = useAppSelector(state => state.medicationDetails.entities);
  const medicationScheduleDetails = useAppSelector(state => state.medicationScheduleDetails.entities);
  const medicationMedicinesEntity = useAppSelector(state => state.medicationMedicines.entity);
  const loading = useAppSelector(state => state.medicationMedicines.loading);
  const updating = useAppSelector(state => state.medicationMedicines.updating);
  const updateSuccess = useAppSelector(state => state.medicationMedicines.updateSuccess);

  const handleClose = () => {
    navigate(`/medication-medicines${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getGlucoUsers({}));
    dispatch(getMedicationDetails({}));
    dispatch(getMedicationScheduleDetails({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.tmDate !== undefined && typeof values.tmDate !== 'number') {
      values.tmDate = Number(values.tmDate);
    }
    if (values.tmStart !== undefined && typeof values.tmStart !== 'number') {
      values.tmStart = Number(values.tmStart);
    }
    if (values.tmEnd !== undefined && typeof values.tmEnd !== 'number') {
      values.tmEnd = Number(values.tmEnd);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }

    const entity = {
      ...medicationMedicinesEntity,
      ...values,
      glucoUser: glucoUsers.find(it => it.id.toString() === values.glucoUser?.toString()),
      medicine: medicationDetails.find(it => it.id.toString() === values.medicine?.toString()),
      scheduleDetail: medicationScheduleDetails.find(it => it.id.toString() === values.scheduleDetail?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...medicationMedicinesEntity,
          glucoUser: medicationMedicinesEntity?.glucoUser?.id,
          medicine: medicationMedicinesEntity?.medicine?.id,
          scheduleDetail: medicationMedicinesEntity?.scheduleDetail?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.medicationMedicines.home.createOrEditLabel" data-cy="MedicationMedicinesCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.medicationMedicines.home.createOrEditLabel">
              Create or edit a MedicationMedicines
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="medication-medicines-id"
                  label={translate('tinyMedicRestApp.medicationMedicines.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationMedicines.tmDate')}
                id="medication-medicines-tmDate"
                name="tmDate"
                data-cy="tmDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationMedicines.tmStart')}
                id="medication-medicines-tmStart"
                name="tmStart"
                data-cy="tmStart"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationMedicines.tmEnd')}
                id="medication-medicines-tmEnd"
                name="tmEnd"
                data-cy="tmEnd"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationMedicines.status')}
                id="medication-medicines-status"
                name="status"
                data-cy="status"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationMedicines.active')}
                id="medication-medicines-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationMedicines.timestampentry')}
                id="medication-medicines-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationMedicines.lastupdated')}
                id="medication-medicines-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationMedicines.cursor')}
                id="medication-medicines-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationMedicines.microSec')}
                id="medication-medicines-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="medication-medicines-glucoUser"
                name="glucoUser"
                data-cy="glucoUser"
                label={translate('tinyMedicRestApp.medicationMedicines.glucoUser')}
                type="select"
                required
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="medication-medicines-medicine"
                name="medicine"
                data-cy="medicine"
                label={translate('tinyMedicRestApp.medicationMedicines.medicine')}
                type="select"
                required
              >
                <option value="" key="0" />
                {medicationDetails
                  ? medicationDetails.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="medication-medicines-scheduleDetail"
                name="scheduleDetail"
                data-cy="scheduleDetail"
                label={translate('tinyMedicRestApp.medicationMedicines.scheduleDetail')}
                type="select"
                required
              >
                <option value="" key="0" />
                {medicationScheduleDetails
                  ? medicationScheduleDetails.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/medication-medicines" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MedicationMedicinesUpdate;
